import { render, staticRenderFns } from "./MRIAnalyseList.vue?vue&type=template&id=5a84b3f6&scoped=true"
import script from "./MRIAnalyseList.vue?vue&type=script&lang=js"
export * from "./MRIAnalyseList.vue?vue&type=script&lang=js"
import style0 from "./MRIAnalyseList.vue?vue&type=style&index=0&id=5a84b3f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84b3f6",
  null
  
)

export default component.exports